module.exports = __webpack_public_path__ + "img/Spadefoot1_20200629.a9989f53.png";